import { useQuery } from "@tanstack/react-query";
import apiService from "../services/apiService";
import { RECON } from "../services/apiConstant";

export const useVehicleSearch = (vin, inventoryStatus = "available", options = {}) => {
  return useQuery({
    queryKey: ["vehicleSearch", vin, inventoryStatus],
    queryFn: async () => {
      if (!vin || !vin.trim()) {
        return [];
      }

      const params = new URLSearchParams();
      if (inventoryStatus) {
        params.append("inventory_status", inventoryStatus);
      }
      const url = `${RECON.inventory}/${vin}${
        params.toString() ? `?${params.toString()}` : ""
      }`;
      const response = await apiService.get(url);
      return response.vehicles || response;
    },
    enabled: !!vin && vin.trim().length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    ...options,
  });
};
